import { useApi, useLoad } from "@allergy123/api-client/react";
import { PROCUREMENT_STATUSES } from "@allergy123/contracts/allergens";
import { Card, Status, Table, Td, Th } from "@allergy123/ui";
import { useState } from "react";
import { Link } from "react-router";
import { CatalogHeader, errorText } from "./common";

export function ProductsPage() {
  const api = useApi();
  const data = useLoad((a) => a.admin.catalog.items());
  const [note, setNote] = useState<string | null>(null);
  async function setStatus(id: string, procurementStatus: (typeof PROCUREMENT_STATUSES)[number]) {
    setNote(null);
    try {
      await api.admin.catalog.updateItem(id, { procurementStatus });
      data.reload();
    } catch (err) {
      setNote(errorText(err));
    }
  }
  return (
    <>
      <CatalogHeader title="Products" intro="What is bought and stocked. NDCs are never invented: a missing NDC stays missing with its recorded reason." />
      {data.state === "error" && <Status kind="error" label={`Couldn't load products (${errorText(data.error)})`} />}
      {note && <div className="mb-6"><Status kind="error" label={note} /></div>}
      <Card>
        <Table caption={data.data ? `${data.data.items.length} products` : "Loading…"}>
          <thead>
            <tr>
              <Th>Product</Th>
              <Th>Labeler</Th>
              <Th>NDC</Th>
              <Th>NDC status</Th>
              <Th>Procurement</Th>
            </tr>
          </thead>
          <tbody>
            {data.data?.items.map((i) => (
              <tr key={i.id}>
                <Td>
                  <Link to={`/catalog/products/${i.id}`} className="font-medium text-anchor underline">{i.manufacturerProductName}</Link>
                </Td>
                <Td>{i.labeler ?? ""}</Td>
                <Td>{i.ndc11 ?? <span className="text-ink-secondary">none</span>}</Td>
                <Td>{i.ndcStatus ?? ""}</Td>
                <Td>
                  <select
                    aria-label={`Procurement status for ${i.manufacturerProductName}`}
                    value={i.procurementStatus}
                    onChange={(e) => void setStatus(i.id, e.target.value as (typeof PROCUREMENT_STATUSES)[number])}
                    className="min-h-10 rounded-sm border border-rule-strong bg-card px-3 py-2 text-body text-ink focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus"
                  >
                    {PROCUREMENT_STATUSES.map((v) => (
                      <option key={v} value={v}>
                        {v}
                      </option>
                    ))}
                  </select>
                </Td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  );
}
